import { render, staticRenderFns } from "./terrace.vue?vue&type=template&id=1996b626&scoped=true&"
import script from "./terrace.vue?vue&type=script&lang=js&"
export * from "./terrace.vue?vue&type=script&lang=js&"
import style0 from "./terrace.vue?vue&type=style&index=0&id=1996b626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996b626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\openy-admin-all\\openy-wxms-web2026-09-01\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1996b626')) {
      api.createRecord('1996b626', component.options)
    } else {
      api.reload('1996b626', component.options)
    }
    module.hot.accept("./terrace.vue?vue&type=template&id=1996b626&scoped=true&", function () {
      api.rerender('1996b626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/terrace.vue"
export default component.exports